import React from 'react';
import { Route } from 'react-router-dom';

import { ProtectedRoute } from '../../shared/auth';
import { RoleName } from '../../shared/auth/role-name';

import { CompanyOrderDetails } from './company-order-details';

function companyOrderDetailsRoute() {
  return (
    <ProtectedRoute
      path="/company-order-details/:id"
      role={RoleName.ROLE_CORPORATE_ADMIN}
      render={(routeProps) => (
        <>
          <Route notAuth path={routeProps.match.url} exact>
            <CompanyOrderDetails orderId={Number(routeProps.match.params.id)} />
          </Route>
        </>
      )}
    />
  );
}

export { companyOrderDetailsRoute };
